module.exports = __webpack_public_path__ + "static/media/who-15.a222ec71.jpg";